import React from 'react';
import styled from 'styled-components';

const RHSection = styled.section`
  width: 100vw;
  display: flex;
  justify-content: center;
  padding: 64px 0;
  background: transparent;
`;

const RHContainer = styled.div`
  width: 1376px;
  height: 438px;
  background: url('/images/rh.png') center/cover no-repeat;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 64px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px 20px;
    background-position: top center;
    background-size: cover;
    border-radius: 0;
  }
`;

const RHContent = styled.div`
  max-width: 580px;
  color: rgb(1, 1, 1);
  font-family: 'Montserrat', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    max-width: 100%;
    align-items: center;
    gap: 20px;
  }

  h2 {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  p {
    font-size: 16px;
    line-height: 1.6;

    @media (max-width: 768px) {
      font-size: 15px;
    }
  }
`;

const CTAButton = styled.a.attrs({
  href: 'https://forms.gle/UatAW55FMX77hGWu5',
  target: '_blank',
  rel: 'noopener noreferrer'
})`
  background: linear-gradient(270deg, #1B1B84 -0.16%, #2AAE3F 99.84%);
  box-shadow: inset 0px -4px 10px rgba(3, 80, 68, 0.16);
  color: #FFFFFF;
  font-family: 'Calmetta', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  padding: 16px 32px;
  border-radius: 100px;
  text-decoration: none;
  width: fit-content;
  cursor: pointer;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;

export default function RHSectionComponent() {
  return (
    <RHSection>
      <RHContainer>
        <RHContent>
          <h2>Transforme o RH da sua empresa</h2>
          <p>Descubra como a Nação Saúde pode ajudar sua equipe a ter mais qualidade de vida e produtividade.</p>
          <CTAButton>Quero uma proposta personalizada</CTAButton>
        </RHContent>
      </RHContainer>
    </RHSection>
  );
}
